export default __webpack_public_path__ + "static/media/@jaqueebatista.0eac9f9b.png";